export enum Level {
  Root = "root",
  LinkfluenceManager = "lf manager",
  LinkfluenceMember = "lf member",
  Partner = "partner",
  Client = "client",
  Application = "application",
}

const LevelIndex: Record<Level, number> = {
  [Level.Root]: 0,
  [Level.LinkfluenceManager]: 5,
  [Level.LinkfluenceMember]: 10,
  [Level.Partner]: 15,
  [Level.Client]: 20,
  [Level.Application]: 25,
};

export function isRoot(level: Level) {
  return LevelIndex[level] <= LevelIndex[Level.Root];
}

export function isLinkfluenceManager(level: Level) {
  return LevelIndex[level] <= LevelIndex[Level.LinkfluenceManager];
}

export function isLinkfluenceInternal(level: Level) {
  return LevelIndex[level] <= LevelIndex[Level.LinkfluenceMember];
}
